// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { _x } from '@wordpress/i18n';

export default {
	items: [
		{
			id: 'run-now-instant-recipes',
			icon: 'bolt',
			title: escapeHTML( _x( 'Run now (instant) recipes', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'import-csv',
			icon: 'file-csv',
			title: escapeHTML( _x( 'Import CSV', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'import-xml',
			icon: 'code',
			title: escapeHTML( _x( 'Import XML', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'data-formatter-generator',
			icon: 'gear',
			title: escapeHTML( _x( 'Data Formatter/Generator', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'date-time-tools',
			icon: 'calendar',
			title: escapeHTML( _x( 'Date and Time tools', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'conditional-actions',
			icon: 'code-merge',
			title: escapeHTML( _x( 'Conditional actions', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'multisite-support',
			icon: 'sitemap',
			title: escapeHTML( _x( 'WordPress Multisite support', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'scheduled-delayed-actions',
			icon: 'clock',
			title: escapeHTML( _x( 'Scheduled/delayed actions', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'loops',
			icon: 'repeat',
			title: escapeHTML( _x( 'Loops', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'create-users',
			icon: 'user',
			title: escapeHTML( _x( 'Create users', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'advanced-log-filters',
			icon: 'filter',
			title: escapeHTML( _x( 'Advanced log filters', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'magic-buttons-magic-links',
			icon: 'wand-magic-sparkles',
			title: escapeHTML( _x( 'Magic buttons and magic links', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'run-php-and-javascript',
			icon: 'code',
			title: escapeHTML( _x( 'Run PHP and JavaScript', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'generate-qr-codes',
			icon: 'qrcode',
			title: escapeHTML( _x( 'Generate QR Codes', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'import-json',
			icon: 'brackets-curly',
			title: escapeHTML( _x( 'Import JSON', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'database-query',
			icon: 'database',
			title: escapeHTML( _x( 'Database query', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'unlimited-app-credits',
			icon: 'share-nodes',
			title: escapeHTML( _x( 'Unlimited app credits', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'receive-webhooks',
			icon: 'webhook',
			title: escapeHTML( _x( 'Receive webhooks', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'premium-support',
			icon: 'heart',
			title: escapeHTML( _x( 'Premium support', 'Upgrade', 'uncanny-automator' ) ),
		},
		{
			id: 'elite-addons',
			icon: 'gem',
			title: escapeHTML( _x( 'Elite Addons', 'Upgrade', 'uncanny-automator' ) ),
		},
	]
};